<div style="width: 100%;">
  <div class="container" style="margin: auto;">
    <div class="row">
      <div class="col-12">
        <br />
      </div>
    </div>
    <div class="row" style="background-color: #006225;">      
      <div class="col-12">
        <div class="row" style="padding-top: 20px; margin-top: 25px; margin-bottom: 25px; margin-left: 15px; margin-right: 15px; border: solid 2px #8dc73f; border-radius: 25px;">
          <div class="col-12">
            <div class="row" style="margin: 0px; background-color: #8dc73f; border-radius: 25px; ">
              <div class="col-12" style="text-align: center;">
                <p style="margin: 10px; font-family: Roboto, sans-serif; font-size: 2.25rem; color: #006225; font-weight: bold;">
                  SITE UNAVAILABLE
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <br /><br />
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="text-align: center;">
                <p style="font-family: Roboto, sans-serif; font-size: 1.25rem; color: white;">
                  Our system is currently down for scheduled maintenance.
                </p>
                <p style="font-family: Roboto, sans-serif; font-size: 1.25rem; color: white;">
                  We apologize for any inconvenience and appreciate your patience.
                </p>
                <p style="font-family: Roboto, sans-serif; font-size: 1.25rem; color: white;">
                  Our team is working hard to get everything back up and running as quickly as possible.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
  </div>
</div>

